<template>
    <div class="header">
        <img
            class="logo"
            src="@/images/apphome/logo-01.png"
            alt=""
        />
        <div class="center"></div>
    </div>
</template>

<script>
/**
 * @file 顶部导航栏
 * @author yinlejia
 * @category 业务组件
 * @tags [component]
 */
export default {
    name: 'Headernav',
    data() {
        return {};
    },
    created() {},
    computed: {},
    methods: {},
};
</script>
<style lang="less" scoped>
.header {
    .logo {
        width: 180px;
        margin-top: -10px;
        position: absolute;
        left: 180px;
    }
    .center {
        width: 1000px;
        height: 80px;
        margin: 0 auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/app/Header.vue